export const DOH_DNS_SERVERS = {
  alibaba: '223.5.5.5',
  tencent: '119.29.29.29',
  google: '8.8.8.8',
  cloudflare: '1.1.1.1'
};

export const DOH_API_ENDPOINTS = {
  alibaba: 'https://dns.alidns.com/resolve',
  tencent: 'https://doh.pub/resolve',
  google: 'https://dns.google/resolve',
  cloudflare: 'https://cloudflare-dns.com/dns-query'
};

export const DOH_SERVER_OPTIONS = [
  { value: 'alibaba', labelKey: 'dns.dohServers.alibaba', ip: DOH_DNS_SERVERS.alibaba },
  { value: 'tencent', labelKey: 'dns.dohServers.tencent', ip: DOH_DNS_SERVERS.tencent },
  { value: 'google', labelKey: 'dns.dohServers.google', ip: DOH_DNS_SERVERS.google },
  { value: 'cloudflare', labelKey: 'dns.dohServers.cloudflare', ip: DOH_DNS_SERVERS.cloudflare }
];

export const AZURE_MAPS_KEY = process.env.REACT_APP_AZURE_MAPS_KEY;
